<template>
    <div class="user-profile">
            <div class="row buttons">
                <li class="col discount-request-btn">
                    <a  class="button primary discount-request-btn" data-title="Discount Al" @click="bonus_modal = true;type = 'discount'" href="javascript:;">
                        <svg viewBox="0 0 1024 1024" class="icon" version="1.1"><path d="M694.59 511.92c-121.21 0-219.47 98.26-219.47 219.47s98.26 219.47 219.47 219.47 219.47-98.26 219.47-219.47-98.26-219.47-219.47-219.47z m0 365.79c-80.69 0-146.33-65.64-146.33-146.33 0-80.69 65.64-146.33 146.33-146.33 80.68 0 146.33 65.64 146.33 146.33 0 80.69-65.65 146.33-146.33 146.33z" fill="#0F1F3C"/><path d="M679.15 753.5l-58.41-51.62-36.32 41.1 99.84 88.27L806.9 690.14l-41.39-36zM200.01 814.55c-23.52-39.54-24.45-87.29-2.48-127.71L411.7 292.57h127.24l101.25 184.96 64.14-35.11-82.03-149.85h35.02v-73.14h-33.38l69.95-146.29H255.02l76.33 146.29H291.6v73.14h36.84l-195.2 359.34c-34.39 63.34-32.93 138.11 3.91 200.04s101.86 98.91 173.91 98.91H437.7v-73.14H311.06c-46.02-0.01-87.53-23.61-111.05-63.17z m175.68-668.26h202.14l-34.98 73.14H413.86l-38.17-73.14z"/></svg>
                        <span>Discount Al</span>
                    </a>
                </li>
                
                <!--<li class="col bonus-request-btn">
                    <a class="button success bonus-request-btn" data-title="Bonus Al" @click="bonus_modal = true;type = 'bonus'" href="javascript:;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 16 16" fill="none"><path d="M3 3V0H5C6.65685 0 8 1.34315 8 3C8 1.34315 9.34315 0 11 0H13V3H16V6H0V3H3Z" fill="#030708"/><path d="M1 8H7V15H1V8Z" fill="#030708"/><path d="M15 8H9V15H15V8Z" fill="#030708"/></svg>
                        <span>Bonus Al</span>
                    </a>
                </li>-->
                <promoCode class="col"  v-if="user"></promoCode>
            </div>
            <div class="bonus-modal" >
                <Modal :isVisible="bonus_modal">
                    <template slot="content">
                        <div class="close-btn button primary" @click="bonus_modal = false;type = ''">
                                <svg xmlns="http://www.w3.org/2000/svg" height="329pt" viewBox="0 0 329.26933 329" width="329pt"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
                        </div>
                        <component is="RequestPage" :propType="type" />
                    </template>
                </Modal>
            </div>
    </div>
</template>
<script>
import promoCode from './Header/promoCode'
import RequestPage from './Header/Request.vue'
  export default{
    data(){
        return{
            bonus_modal: false,
        }
    },
    computed:{
        user(){
          return this.$user();
        },
        user_detail(){
          return this.$user_detail();
        }
    },
    components:{
        RequestPage,
        promoCode,
    },
    methods:{
            triggerPanel(panel){
                this.$emit('triggerPanel', panel)
            }
    }
  }
</script>

<style scoped lang="scss">
    .user-profile{
        .top{
            display: flex;
            text-align: left;
            flex-direction: column;
            padding: 10px 10px 0px 10px;
            font-weight: 600;
            p{
                display: flex;
                margin: 0px;
                align-items: center;
                img{
                    margin-right: 5px;
                }
            }
            h3{
                text-align: left;
                margin: 5px 0px;
                font-size: 12px;
            }
        }
        .buttons{
            margin: 0px !important;
            border:none !important;
            padding: 5px 0 !important;
            .button{
                width: 100%;
                font-weight: 600;
                font-size: 13px;
                padding: 15px 0;
                svg{
                    margin-right: 5px;
                }
                &.secondary{
                    svg{
                        fill: #fff !important;
                    }
                }
            }
        }
    }
</style>